import { boot } from "quasar/wrappers";
let versionData = null;
export default boot(async () => {
    try {
        const res = await fetch("version.json", { cache: "no-store" });
        if (!res.ok) {
            throw new Error(`Failed to load version.json (${res.status})`);
        }
        versionData = (await res.json());
    }
    catch (ex) {
        console.error("version.jsonの読み込みに失敗しました:", ex);
        versionData = {
            appJsHash: "unknown",
            vendorJsHash: "unknown",
            timestamp: new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })
        };
    }
});
export function useAppVersion() {
    return versionData;
}
